export function buildRevenueSongsExportRows(songs = []) {
  return (songs || []).map((song) => ({
    'Song Name': song.name || song.nameSinhala || '',
    'Sinhala Song Name': song.nameSinhala || song.name || '',
    'ISRC Code': song.isrcCode || song.isrc || '',
    Ownership: formatOwnership(song.ownership),
    Artist: song.artist || '',
    Income: song.income || song.totalRevenue || '$0.00',
    Distributor: song.distributor || '$0.00',
    Earning: song.earning || '$0.00',
    Outgoing: song.outgoing || '$0.00'
  }));
}

function formatOwnership(value) {
  if (value === undefined || value === null || value === '') return '100%';
  if (typeof value === 'number') return `${value}%`;
  const text = String(value).trim();
  if (!text) return '100%';
  return text.endsWith('%') ? text : `${text}%`;
}

export function exportRevenueSongsCsv(rows, filename = 'revenue_songs_export.csv') {
  const headers = [
    'Song Name',
    'Sinhala Song Name',
    'ISRC Code',
    'Ownership',
    'Artist',
    'Income',
    'Distributor',
    'Earning',
    'Outgoing'
  ];

  const csvRows = [headers.join(',')];
  rows.forEach((row) => {
    const values = headers.map((header) => {
      const value = row[header] ?? '';
      const escaped = String(value).replace(/"/g, '""');
      return `"${escaped}"`;
    });
    csvRows.push(values.join(','));
  });

  const blob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  if (link.parentNode) link.parentNode.removeChild(link);
  window.URL.revokeObjectURL(url);
}
